import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Mail, Lock, ArrowLeft } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Giriş başarılı");
      nav(u.role === "admin" ? "/adc" : "/dashboard");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-gradient-to-br from-blue-700 to-indigo-800 text-white p-12 relative overflow-hidden">
        <div className="absolute inset-0 hero-grid opacity-40" />
        <Link to="/" className="relative"><Logo className="[&_span]:text-white" /></Link>
        <div className="relative">
          <h2 className="font-display text-4xl font-extrabold leading-tight">Topluluğun<br />gücüyle güvende kalın.</h2>
          <p className="text-blue-100 mt-4 max-w-md">Numaraları sorgulayın, dolandırıcıları raporlayın ve kendi SEO uyumlu sayfalarınızı yayınlayın.</p>
        </div>
        <div className="relative text-blue-200 text-sm">sorgupanel.org</div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 bg-background">
        <div className="w-full max-w-sm">
          <Link to="/" className="inline-flex items-center gap-1 text-sm text-slate-400 hover:text-blue-600 mb-8"><ArrowLeft className="h-4 w-4" /> Anasayfa</Link>
          <div className="lg:hidden mb-6"><Logo /></div>
          <h1 className="font-display text-2xl font-bold text-slate-900 dark:text-white">Giriş Yap</h1>
          <p className="text-slate-500 mt-1 mb-8">Hesabınıza erişin</p>

          <form onSubmit={submit} className="space-y-4">
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
              <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-posta" className="pl-10 h-11" />
            </div>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
              <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Şifre" className="pl-10 h-11" />
            </div>
            <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full h-11 bg-blue-600 hover:bg-blue-700">
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </Button>
          </form>
          <p className="text-sm text-slate-500 mt-6 text-center">
            Hesabınız yok mu? <Link to="/register" className="text-blue-600 font-medium" data-testid="go-register">Kayıt olun</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
